import { Wallet, Clock } from 'lucide-react';
import { CashbackSummary } from '@/data/types';

interface CashbackSummaryCardProps {
  summary: CashbackSummary | undefined;
  loading?: boolean;
  /** Display unit from user country (e.g. ر.س / ج.م) */
  currencySymbol?: string;
}

export function CashbackSummaryCard({
  summary,
  loading = false,
  currencySymbol = 'ر.س',
}: CashbackSummaryCardProps) {
  const available = summary?.availableBalance ?? 0;
  const pending = summary?.pendingBalance ?? 0;

  if (loading) {
    return (
      <div className="mx-4 mb-4 rounded-2xl bg-primary/20 h-32 animate-pulse" />
    );
  }

  return (
    <div className="mx-4 mb-4 rounded-2xl bg-gradient-to-br from-amber-400 to-yellow-500 shadow-md overflow-hidden">
      {/* Top row — balance */}
      <div className="px-5 pt-5 pb-3">
        <div className="flex items-start justify-between mb-1">
          <p className="text-xs font-medium text-amber-900/70 tracking-wide">رصيد الكاش باك</p>
          <Wallet className="w-5 h-5 text-amber-900/50" />
        </div>
        <div className="flex items-baseline gap-1.5">
          <span className="text-3xl font-extrabold text-amber-950 tabular-nums leading-none">
            {available.toFixed(2)}
          </span>
          <span className="text-sm font-semibold text-amber-900/70">{currencySymbol}</span>
        </div>
      </div>

      {/* Divider */}
      <div className="mx-5 border-t border-amber-900/15" />

      {/* Bottom row — pending */}
      <div className="px-5 py-3 flex items-center">
        <div className="flex items-center gap-1.5">
          <Clock className="w-3.5 h-3.5 text-amber-900/60" />
          <span className="text-xs text-amber-900/70">قيد المراجعة</span>
          <span className="text-xs font-bold text-amber-950 tabular-nums">
            {pending.toFixed(2)} {currencySymbol}
          </span>
        </div>
      </div>
    </div>
  );
}
